import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);
import { Line } from 'react-chartjs-2';
type KPI = {
    title: string;
    budget: number;
    forecast: number;
};

const kpis = [
    { title: 'Sales', budget: 1200, forecast: 1050, trend: [120, 130, 125, 140, 110, 115] ,color : '#FFC107'},
    { title: 'Production', budget: 900, forecast: 950, trend: [90, 100, 95, 105, 95, 100], color : '#198754' },
    { title: 'Inventory', budget: 700, forecast: 720, trend: [100, 98, 102, 99, 101, 97], color : '#198754' },
    { title: 'Gross Profit', budget: 500, forecast: 450, trend: [60, 70, 65, 68, 58, 55], color : '#FFC107' }
  


];

const getStatusClass = (forecast: number, budget: number): string => {
    const ratio = forecast / budget;
    if (ratio >= 0.95) return 'border-success';
    if (ratio >= 0.80) return 'border-warning';
    return 'border-danger';
};

const SopPrincipalKPICards: React.FC = () => (
    <Row className="mb-4">
        {kpis.map(({ title, budget, forecast, trend,color }, idx) => (
            <Col md={3} key={idx}>
                <Card className={`shadow-sm  ${getStatusClass(forecast, budget)}`}>
                    <Card.Body>

                        <h6 className="text-uppercase text-muted">{title}</h6>
                        <h4 className="fw-bold">${forecast}</h4>
                        <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">Budget</small>
                            <small className="text-danger fw-bold"></small>
                        </div>
                        <small className="text-muted">${budget}</small>
                        <Line
                            data={{
                                labels: ['', '', '', '', '', ''],
                                datasets: [
                                    {
                                        data: trend,
                                        fill: false,
                                        tension: 0.3,
                                        pointRadius: 0,
                                        borderColor: color,
                                        backgroundColor: color,
                                    },
                                ],
                            }}
                            options={{
                                responsive: true,
                                plugins: { legend: { display: false } },
                                scales: { x: { display: false }, y: { display: false } },

                            }}
                            height={60}
                        />
                        <div className="d-flex justify-content-end mt-2">
                            <span
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    backgroundColor: color,
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                }}
                            ></span>
                        </div>

                        {/* <Card.Title className="fs-6 text-uppercase">{title}</Card.Title>
                        <div className="fw-bold text-dark">Forecast: ${forecast}K</div>
                        <div className="text-muted">Budget: ${budget}K</div>
                        <div className="mt-2 small text-secondary"> 
                             <Line
                            data={{
                                labels: ['', '', '', '', '', ''],
                                datasets: [
                                    {
                                        data: trend,
                                        fill: false,
                                        borderColor: '#999',
                                        tension: 0.3,
                                        pointRadius: 0,
                                    },
                                ],
                            }}
                            options={{
                                responsive: true,
                                plugins: { legend: { display: false } },
                                scales: { x: { display: false }, y: { display: false } },
                            }}
                            height={60}
                        /></div> */}
                       
                    </Card.Body>
                </Card>
            </Col>
        ))}
    </Row>
);

export default SopPrincipalKPICards;
